export enum InvoiceStatus {
  INVOICE_STATUS_NOT_PAID,
  INVOICE_STATUS_PENDING,
  INVOICE_STATUS_APPROVED,
  INVOICE_STATUS_REFUSED,
  INVOICE_STATUS_DISABLED,
  INVOICE_STATUS_EXPIRED,
  INVOICE_STATUS_MANUAL,
}

export interface InvoiceList {
  id: number;
  title: string;
  code: number;
  create_time: number;
  amount: number;
  status: InvoiceStatus;
}

export interface InvoicesResponse {
  data: InvoiceList[];
  meta: {
    page: number;
    pageSize: number;
    total: number;
  };
}

export interface InvoicesQueryParams {
  status?: InvoiceStatus;
  dateFrom?: number;
  dateTo?: number;
  page: number;
  pageSize: number;
}
